import { getJSON } from 'bv';
import { locale, logged_in as loggedIn } from 'state';

export default () => (
  getJSON('/api/left_components', {
    c: locale(),
    l: loggedIn(),
  })
    .catch(() => [])
);
